import './header.css';
import React from 'react';

export function Header() {
  return (
    <header className="header">
        <span>JSRF Trainer</span>
      </header>
  )
}